import React from "react";
import { Link } from "react-router-dom";

const GuestGoodbyePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#05020d] via-[#160431] to-[#1b053c] text-white flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center space-y-5 rounded-3xl border border-white/10 bg-white/5 backdrop-blur px-8 py-10 shadow-[0_45px_120px_rgba(0,0,0,0.45)]">
        <div className="text-3xl font-black tracking-tight">
          <span className="bg-gradient-to-r from-amber-300 via-amber-200 to-amber-400 bg-clip-text text-transparent drop-shadow-[0_8px_24px_rgba(251,191,36,0.8)]">
            Thanks for joining!
          </span>
        </div>
        <p className="text-slate-200 text-sm leading-relaxed">
          This session has ended. No account or password is needed—just use the invite link next time to jump straight into the room.
        </p>
        <div className="flex items-center justify-center gap-3 text-sm">
          <a
            href="https://whipt.app"
            className="px-5 py-3 rounded-full bg-amber-300 text-slate-900 font-semibold uppercase tracking-[0.25em] shadow-[0_12px_30px_rgba(248,191,22,0.35)] hover:bg-amber-200 transition-colors"
          >
            Visit homepage
          </a>
        </div>
      </div>
    </div>
  );
};

export default GuestGoodbyePage;
